// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"styles_Wrapper__NIwHw"};